import Assign from './Assign/Assign';
import Append from './Append/Append';
import ConvertXmlToObject from './ConvertXmlToObject/ConvertXmlToObject';
import Search from './Search/Search';
import RemoveKeys from './RemoveKeys/RemoveKeys';
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, variableRender, disabled, automId, automVersionId, automDetail, visible) {
    if (action.actionName === types.ASSIGN)
        return <Assign action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} visible={visible} />;
    else if (action.actionName === types.APPEND)
        return <Append action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} disabled={disabled} visible={visible} />;
    else if (action.actionName === types.SEARCH)
        return <Search action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} disabled={disabled} automId={automId} automVersionId={automVersionId} automDetail={automDetail} />;
    else if (action.actionName === types.CONVERTXMLTOOBJECT)
        return <ConvertXmlToObject action={action} variables={variables} setOpenVariable={setOpenVariable}
            showAlert={showAlert} automId={automId} />;
    if (action.actionName === types.REMOVEKEYS)
        return <RemoveKeys action={action} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} visible={visible} />;
}

export default Actions;
